let resendInterval;


$('.step--1 form').on('submit', function (e) {
	e.preventDefault();

	const mobile = $('#mobileInput').val();

	$.post('/home/ajax-verify-send/', { mobile }, function (res) {
		console.log(res);
		if (res.success) {
			$('.step').hide();
			$('.step--2').show();
			startResendCountdown();
		} else {
			console.log(res);
			alert(res.message || 'Failed to send code');
		}
	}, 'json').fail(function (xhr, status, error) {
		console.error('AJAX error:', status, error);
		alert('There was a problem sending the code. Please try again.');
	});
});

$('.step--2 form').on('submit', function (e) {
	e.preventDefault();

	const code = $('#codeInput').val();
	const $error = $('#codeError');

	$.post('/home/ajax-verify-check/', { code }, function (res) {
		if (res.success) {
			$('.step').hide();
			$('.step--3').show();
		} else {
			$error.text(res.message || 'Invalid code').show();
		}
	}, 'json');
});

// Close modal with "I'll do this later"
$('.modal__verify--skip').on('click', function (e) {
	e.preventDefault();
	$('.modal__verify').removeClass('open');
	$('body').removeClass('modal-open');
});

$('.modal__verify--open').on('click', function (e) {
	e.preventDefault();
	$('.modal__verify').addClass('open');
	$('body').addClass('modal-open');
});

function startResendCountdown(duration = 60) {
	let time = duration;
	const $link = $('#resendLink');
	const $timer = $('#resendTimer');

	$link.addClass('disabled').attr('aria-disabled', 'true');

	const interval = setInterval(() => {
		const minutes = Math.floor(time / 60);
		const seconds = (time % 60).toString().padStart(2, '0');
		$timer.text(`${minutes}:${seconds}`);

		if (--time < 0) {
			clearInterval(interval);
			$link.removeClass('disabled').removeAttr('aria-disabled');
			$link.text('Re-send code');
		}
	}, 1000);
}


$('#resendLink').on('click', function (e) {
	e.preventDefault();
	if ($(this).hasClass('disabled')) return;

	$.post('/home/ajax-verify-send/', {}, function (res) {
		if (res.success) {
			$('#codeStatus').text('A new code has been sent to your phone.').show();
			startResendCountdown();
		} else {
			$('#codeStatus').text(res.message || 'Failed to resend code.').show();
		}
	}, 'json');
});


function startResendCountdown(duration = 60) {
	clearInterval(resendInterval); // clear any existing timer

	let time = duration;
	const $link = $('#resendLink');
	const $timer = $('#resendTimer');

	$link
		.addClass('disabled')
		.attr('aria-disabled', 'true')
		.html('Re-send code in <span id="resendTimer">1:00</span>'); // ✅ reset text immediately

	resendInterval = setInterval(() => {
		const minutes = Math.floor(time / 60);
		const seconds = (time % 60).toString().padStart(2, '0');
		$('#resendTimer').text(`${minutes}:${seconds}`);

		if (--time < 0) {
			clearInterval(resendInterval);
			$link.removeClass('disabled').removeAttr('aria-disabled').text('Re-send code');
		}
	}, 1000);
}